import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { DerivedTextField } from './DerivedTextField';

/**
 * Registers the `DerivedText` field for `ui:field` in templates:
 *
 * ```yaml
 * domainName:
 *   type: string
 *   ui:field: DerivedText
 *   ui:options:
 *     derivedFrom: serviceName
 * ```
 */
export const DerivedTextFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DerivedText',
    component: DerivedTextField,
  }),
);
